import { css } from 'styled-components';
import { pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const iconButtonBase = css `
  flex-shrink: 0;

  ${({ $round }) => $round &&
    `
    border-radius: ${themeGet('borderRadius.circle')};
  `}
`;
const defaultPrimaryAppearance = css `
  color: ${themeGet('colors.text.200')};
  border-color: ${themeGet('colors.border.100')};
  background-color: ${themeGet('colors.primary.0')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.primary.600')};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      [data-icon='falcon'] {
        color: ${themeGet('colors.primary.1000')};
      }

      color: ${themeGet('colors.primary.1000')};
      border-color: ${themeGet('colors.primary.1000')};
      background-color: ${themeGet('colors.primary.100')};
    }

    &:active {
      background-color: ${themeGet('colors.primary.100')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(4)} ${themeGet('colors.focus.primary')};
    }
  }
`;
const toggledPrimaryAppearance = css `
  color: ${themeGet('colors.primary.1000')};
  border-color: ${themeGet('colors.primary.1000')};
  background-color: ${themeGet('colors.primary.50')};

  [data-icon='falcon'] {
    color: ${themeGet('colors.primary.1000')};
  }

  &:disabled {
    opacity: 0.5;
  }

  &:not(:disabled) {
    &:hover {
      background-color: ${themeGet('colors.primary.0')};
    }

    &:active {
      background-color: ${themeGet('colors.primary.100')};
    }

    &:focus-visible {
      box-shadow: 0 0 0 ${pxToRem(4)} ${themeGet('colors.focus.primary')};
    }
  }
`;
export const getToggleButtonAppearance = (appearance, toggled) => {
    if (toggled) {
        switch (appearance) {
            case 'primary':
            default:
                return toggledPrimaryAppearance;
        }
    }
    switch (appearance) {
        case 'primary':
        default:
            return defaultPrimaryAppearance;
    }
};
